import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";

export default function BuildingContextSelector({ building, floors, onFloorSelect, onBackToCampus }) {
  const [open, setOpen] = useState(false);

  if (!building) return null;

  const container = {
    width: "500px",
    background: "#ffffff",
    borderRadius: "14px",
    boxShadow: "0 6px 16px rgba(0,0,0,0.10)",
    overflow: "hidden",
    marginBottom: "18px",
    position: "fixed",
    right: "10px",
    top: "10px"
  };

  const breadcrumbRow = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 18px",
    fontSize: "12px",
    color: "#777",
    borderBottom: "1px solid #eee",
    background: "#fafafa"
  };

  const crumbLink = {
    cursor: "pointer",
    fontWeight: 600,
    color: "#333",
    display: "flex",
    alignItems: "center",
    gap: "6px"
  };

  const crumbCurrent = {
    fontWeight: 600,
    color: "#f4c400"
  };

  const header = {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    padding: "14px 18px",
    cursor: "pointer"
  };

  const imageStyle = {
    width: "80px",
    height: "60px",
    borderRadius: "10px",
    objectFit: "cover",
    boxShadow: "0 4px 10px rgba(0,0,0,0.12)"
  };

  const titleBlock = {
    display: "flex",
    flexDirection: "column",
    flex: 1
  };

  const buildingName = {
    fontSize: "16px",
    fontWeight: 600,
    color: "#111"
  };

  const subtitle = {
    fontSize: "12px",
    color: "#777"
  };

  const chevron = {
    fontSize: "14px",
    color: "#999",
    transition: "transform 0.3s ease",
    transform: open ? "rotate(180deg)" : "rotate(0deg)"
  };

  const dropdown = {
    maxHeight: open ? "420px" : "0px",
    overflow: "hidden",
    transition: "max-height 0.45s ease",
    borderTop: "1px solid #eee"
  };

  const floorRow = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 18px",
    cursor: "pointer",
    borderBottom: "1px solid #f0f0f0",
    transition: "background 0.2s ease"
  };

  const floorName = {
    fontSize: "13px",
    fontWeight: 600,
    color: "#222",
    flex: 1
  };

  const deskInfo = {
    fontSize: "11px",
    color: "#777"
  };

  const occupancyBarBg = {
    width: "80px",
    height: "6px",
    background: "#eee",
    borderRadius: "4px",
    overflow: "hidden"
  };

  const occupancyBarFill = (pct) => ({
    width: `${pct}%`,
    height: "100%",
    background: "#f4c400",
    borderRadius: "4px"
  });

  return (
    <div style={container}>

      {/* Breadcrumb */}
      <div style={breadcrumbRow}>
        <div
          style={crumbLink}
          onClick={() => onBackToCampus && onBackToCampus()}
        >
          <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: "11px" }} />
          Campus
        </div>

        <span>/</span>

        <div style={crumbCurrent}>{building.name}</div>
      </div>

      {/* Header */}
      <div style={header} onClick={() => setOpen(!open)}>
        <img src={building.image} alt={building.name} style={imageStyle} />
        <div style={titleBlock}>
          <div style={buildingName}>{building.name}</div>
          <div style={subtitle}>{building.location}</div>
        </div>
        <FontAwesomeIcon icon={faChevronDown} style={chevron} />
      </div>

      {/* Floors dropdown */}
      <div style={dropdown}>
        {floors.map((floor, idx) => (
          <div
            key={idx}
            style={floorRow}
            onClick={() => {
              setOpen(false);
              onFloorSelect && onFloorSelect(floor);
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = "#f9f9f9"}
            onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}
          >
            <div style={floorName}>{floor.name}</div>
            <div style={deskInfo}>{floor.desks} desks</div>

            <div style={occupancyBarBg}>
              <div style={occupancyBarFill(floor.occupancy)} />
            </div>

            <FontAwesomeIcon
              icon={faChevronRight}
              style={{ color: "#f4c400", fontSize: "13px" }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
